import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface Country {
  id: string;
  name: string;
  code: string;
  flagImageUrl: string | null;
  displayOrder: number;
}

export const useSupportedCountries = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true);
        const { data, error: fetchError } = await supabase
          .from('supported_countries')
          .select('*')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        if (fetchError) throw fetchError;

        const mapped: Country[] = (data || []).map(c => ({
          id: c.id,
          name: c.country_name,
          code: c.country_code,
          flagImageUrl: c.flag_image_url,
          displayOrder: c.display_order,
        }));

        setCountries(mapped);
      } catch (err) {
        console.error('Error fetching countries:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch countries');
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  return { countries, loading, error };
};
